export function endOfGridRow(index, columnCount) {
  return Math.floor(index / columnCount) * columnCount + columnCount - 1;
}

/**
 * DOM order for inline-expanding tiles:
 * 1) tiles in the open tile's row (through end of that row)
 * 2) full-width ingredient panel
 * 3) tiles from following rows
 */
export function buildFloatingTileItems(groups, openIndex, columnCount) {
  if (openIndex < 0) {
    return groups.map((group, index) => ({ type: 'card', group, index }));
  }

  const rowEnd = Math.min(groups.length - 1, endOfGridRow(openIndex, columnCount));
  const items = [];

  for (let i = 0; i <= rowEnd; i += 1) {
    items.push({ type: 'card', group: groups[i], index: i });
  }

  items.push({ type: 'panel', group: groups[openIndex], index: openIndex });

  for (let i = rowEnd + 1; i < groups.length; i += 1) {
    items.push({ type: 'card', group: groups[i], index: i });
  }

  return items;
}
